"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Util that stops propagation and prevents default behavior on events
 */
function stopDefault(cb) {
  return function (event) {
    event.preventDefault();
    event.stopPropagation();
    cb === null || cb === void 0 ? void 0 : cb(event);
  };
}
var _default = stopDefault;
exports["default"] = _default;